import { createAction, props } from '@ngrx/store';
import { SkyClubEntity } from '../../models/sky-club.entities';

export const loadAEMContent = createAction('[Sky Club/AEM] Load AEM Content');

export const loadAEMContentSuccess = createAction(
  '[Sky Club/AEM] Load AEM Content Success',
  props<{ aemContent: SkyClubEntity }>()
);

export const loadAEMContentFailure = createAction(
  '[Sky Club/AEM] Load AEM Content Fail',
  props<{ aemContentError: SkyClubEntity }>()
);
